<div class="iniziative-container">
    <div class="schedule-item">
        <a mat-button href="/cifris24/program#25morning" class="txtbtn">
                <div class="month">Sept.</div>
                <div class="day"><b>25</b><i>th</i></div>
                <div class="time">morning</div>
        </a>
    </div>
    <div class="schedule-item">
        <a mat-button href="/cifris24/program#25afternoon" class="txtbtn">
                <div class="month">Sept.</div>
                <div class="day"><b>25</b><i>th</i></div>
                <div class="time">afternoon</div>
        </a>
    </div>
    <div class="schedule-item">
        <a mat-button href="/cifris24/program#25evening" class="txtbtn">
                <div class="month">Sept.</div>
                <div class="day"><b>25</b><i>th</i></div>
                <div class="time">evening</div>
        </a>
    </div>
    <div class="schedule-item">
        <a mat-button href="/cifris24/program#26morning" class="txtbtn">
                <div class="month">Sept.</div>
                <div class="day"><b>26</b><i>th</i></div>
                <div class="time">morning</div>
        </a>
    </div>
    <div class="schedule-item">
        <a mat-button href="/cifris24/program#26afternoon" class="txtbtn">
                <div class="month">Sept.</div>
                <div class="day"><b>26</b><i>th</i></div>
                <div class="time">afternoon</div>
        </a>
    </div>
    <div class="schedule-item">
        <a mat-button href="/cifris24/program#27morning" class="txtbtn">
                <div class="month">Sept.</div>
                <div class="day"><b>27</b><i>th</i></div>
                <div class="time">morning</div>
        </a>
    </div>
    <div class="schedule-item">
        <a mat-button href="/cifris24/program#27afternoon" class="txtbtn">
                <div class="month">Sept.</div>
                <div class="day"><b>27</b><i>th</i></div>
                <div class="time">afternoon</div>
        </a>
    </div>
</div>